package uz.ferro.erp.feature.faq.ui

import mui.material.Accordion
import mui.material.AccordionDetails
import mui.material.AccordionSummary
import mui.material.Typography
import react.FC
import react.Props
import uz.ferro.erp.feature.faq.model.FaqItem
import uz.ferro.erp.feature.text.ui.DocContentView

external interface FaqItemViewProps : Props {
    var item: FaqItem
}

val FaqItemView = FC<FaqItemViewProps> { props ->
    val item = props.item
    Accordion {
        AccordionSummary {
            Typography {
                +item.title
            }
        }

        AccordionDetails {
            DocContentView {
                content = item.content
            }
        }
    }
}